export function initOnboarding() {
  const panels = document.querySelectorAll('[data-step-panel]');
  const nextBtn = document.querySelector('[data-onboarding-next]');
  const prevBtn = document.querySelector('[data-onboarding-prev]');
  const indicators = document.querySelectorAll('[data-step-indicator]');
  const connectors = document.querySelectorAll('[data-connector]');
  const dots = document.querySelectorAll('[data-dot]');
  const nav = document.getElementById('onboarding-nav');

  if (!panels.length || !nextBtn || !prevBtn) return;

  let current = 1;
  const total = panels.length;

  function showStep(step) {
    current = step;

    panels.forEach((panel, i) => {
      panel.classList.toggle('hidden', i + 1 !== step);
    });

    indicators.forEach(ind => {
      const s = parseInt(ind.dataset.stepIndicator);
      const circle = ind.querySelector('div');
      const label = ind.querySelector('span');
      if (s < step) {
        circle.className = 'w-8 h-8 rounded-full bg-dcco-secondary text-white flex items-center justify-center text-sm font-bold z-10 transition-colors';
        circle.innerHTML = '<i class="fa-light fa-check text-xs"></i>';
        label.className = 'text-xs text-dcco-secondary font-medium mt-1 whitespace-nowrap';
      } else if (s === step) {
        circle.className = 'w-8 h-8 rounded-full bg-dcco-secondary text-white flex items-center justify-center text-sm font-bold z-10 transition-colors';
        circle.textContent = s;
        label.className = 'text-xs text-dcco-secondary font-medium mt-1 whitespace-nowrap';
      } else {
        circle.className = 'w-8 h-8 rounded-full bg-gray-200 dark:bg-dcco-border-dark text-dcco-muted flex items-center justify-center text-sm font-bold z-10 transition-colors';
        circle.textContent = s;
        label.className = 'text-xs text-dcco-muted mt-1 whitespace-nowrap';
      }
    });

    connectors.forEach(conn => {
      const s = parseInt(conn.dataset.connector);
      if (s < step) {
        conn.className = conn.className.replace(/bg-gray-200 dark:bg-dcco-border-dark/g, 'bg-dcco-secondary');
        conn.classList.remove('bg-gray-200', 'dark:bg-dcco-border-dark');
        conn.classList.add('bg-dcco-secondary');
      } else {
        conn.classList.remove('bg-dcco-secondary');
        conn.classList.add('bg-gray-200', 'dark:bg-dcco-border-dark');
      }
    });

    dots.forEach(dot => {
      const s = parseInt(dot.dataset.dot);
      if (s === step) {
        dot.className = 'w-6 h-1.5 rounded-full bg-dcco-secondary';
      } else if (s < step) {
        dot.className = 'w-1.5 h-1.5 rounded-full bg-dcco-secondary';
      } else {
        dot.className = 'w-1.5 h-1.5 rounded-full bg-gray-300 dark:bg-dcco-border-dark';
      }
    });

    prevBtn.disabled = step === 1;
    prevBtn.classList.toggle('opacity-50', step === 1);

    if (step === total) {
      nav.classList.add('hidden');
    } else {
      nav.classList.remove('hidden');
      nextBtn.innerHTML = step === total - 1
        ? 'إنهاء <i class="fa-light fa-check ms-2"></i>'
        : 'التالي <i class="fa-light fa-arrow-left ms-2"></i>';
    }
  }

  nextBtn.addEventListener('click', () => {
    if (current < total) showStep(current + 1);
  });

  prevBtn.addEventListener('click', () => {
    if (current > 1) showStep(current - 1);
  });

  showStep(1);
}
